// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_3wGkR","showOverlay":"_1nvNs","fixedBody":"_1BOVS"};